import TIM from 'tim-js-sdk';
import TIMUploadPlugin  from 'tim-upload-plugin';
import Vue from 'vue'
let tim = TIM.create({ SDKAppID: process.env.VUE_APP_SDKID });
console.log(process.env.VUE_APP_LOG_LEVEL)
tim.setLogLevel(process.env.VUE_APP_LOG_LEVEL);


// 注册腾讯云即时通信 IM 上传插件，即时通信 IM SDK 发送图片、语音、视频、文件等消息需要使用上传插件，将文件上传到腾讯云对象存储
tim.registerPlugin({'tim-upload-plugin': TIMUploadPlugin});

Vue.prototype.$TIM = TIM
Vue.prototype.$tim = tim
export default tim

